import { z } from 'zod';

export const MEASUREMENT_BOUNDS = {
  height: [140, 200],
  bust: [50, 150],
  waist: [50, 150],
  hips: [50, 150],
} as const;

export type MeasurementKey = keyof typeof MEASUREMENT_BOUNDS;

const measurement = (key: MeasurementKey) =>
  z.number().int().min(MEASUREMENT_BOUNDS[key][0]).max(MEASUREMENT_BOUNDS[key][1]);

export const SizeAdviceRequestSchema = z
  .object({
    productSlug: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    height: measurement('height'),
    bust: measurement('bust'),
    waist: measurement('waist'),
    hips: measurement('hips'),
  })
  .strict();
export type SizeAdviceRequest = z.infer<typeof SizeAdviceRequestSchema>;

export const SizeAdviceSchema = z.object({
  recommended: z.string(),
  /** Explanation for every size of the grid, keyed by size. */
  notes: z.record(z.string(), z.string()),
});
export type SizeAdvice = z.infer<typeof SizeAdviceSchema>;
